import { createSlice } from '@reduxjs/toolkit'

import { createCardToken } from './actions/create_card_token'

const initialState = {
  loading: true,
  paypalExpressCheckoutUrl: null,
  token: null,
  stripeFormComplete: false,
}

const checkoutPaymentMethodSlice = createSlice({
  name: 'checkoutPaymentMethod',
  initialState,
  reducers: {
    resetToken: (state) => {
      state.token = null
    },
    setPaypalExpressCheckoutUrl: (state, action) => {
      state.paypalExpressCheckoutUrl = action.payload
    },
    setToken: (state, action) => {
      state.token = action.payload
    },
    startLoading: (state) => {
      state.loading = true
    },
    stopLoading: (state) => {
      state.loading = false
    },
    setStripeFormComplete: (state, action) => {
      state.stripeFormComplete = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(createCardToken.fulfilled, (state, action) => {
      state.token = action.payload
    })
    builder.addCase(createCardToken.rejected, (state) => {
      state.token = null
    })
  }
})

export const {
  reducer,
  actions: {
    resetToken,
    setPaypalExpressCheckoutUrl,
    setToken,
    startLoading,
    stopLoading,
    setStripeFormComplete
  }
} = checkoutPaymentMethodSlice
